import { z } from "zod";

export const ServiceTypeItemSchema = z.object({
  Id: z.string().uuid(),
  Name: z.string().optional(),
  Description: z.string().optional(),
  StateCode: z.number().optional(),
  StatusCode: z.number().optional(),
});

export type ServiceTypeItemType = z.infer<typeof ServiceTypeItemSchema>;

export const ServiceTypeState = {
  ACTIVE: 0,
  INACTIVE: 1,
} as const;
